import React from 'react'
import Layout from '../Layout'
import First_Pane  from './First_pane'

const Biote_lapis_II = () => {
  return (
    <Layout>
        <First_Pane />
    </Layout>
  )
}

export default Biote_lapis_II